import { Component } from '@angular/core';

@Component({
  selector: 'kh-info-box',
  styleUrls: ['./info-box.component.less'],
  templateUrl: './info-box.component.html',
  standalone: false
})
export class InfoBoxComponent {

}
